export const NamList = (pageIndex , pageOptions , gotoPage) =>{
    let numlist = [] 
    if (pageIndex < 3) {
      for (let i = 0; i <= 5; i++) {
          if (pageOptions.includes(i)) 
          numlist.push(i);
      }
    }
    else {
        for (let i = pageIndex - 2; i < pageIndex + 3; i++) {
            if (pageOptions.includes(i)) 
            numlist.push(i);
        }
    }
    
    return numlist.map((item , index)=> 
    <span className={pageIndex == item ? "num active": "num"} onClick={() => gotoPage(item)}
    key={index}> 
      {item + 1}
    </span>)
  }